import React, { useContext, useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Form,
  FormGroup,
  Input,
  ModalBody,
  ModalFooter,
  Row,
  Spinner,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"
import SendEmail from "../../common/config/send-email"
import toast from "react-hot-toast"

const EmailModal = ({ setActiveTab }) => {
  const { bookingDetails, fetchSubscribeKey, subscribeKey } =
    useContext(DataContext)

  const [emailValues, setEmailValues] = useState({
    sendToCustomer: true,
    sendToCompany: true,
    sendSmsToCustomer: false,
  })

  const [loading, setLoading] = useState(false) // Loader state

  useEffect(() => {
    if (bookingDetails?.bookingDetails?.length > 0) {
      const detail = bookingDetails.bookingDetails.find(
        detail => detail?.is_current === true || detail?.is_current === 1
      )
      if (detail) {
        setEmailValues(prevValues => ({
          ...prevValues,
          sendSmsToCustomer: detail?.sms_status ? true : false,
        }))
      }
    }
  }, [])

  useEffect(() => {
    if (bookingDetails) {
      fetchSubscribeKey()
    }
  }, [bookingDetails])

  const handleChange = e => {
    const { name, checked } = e.target
    setEmailValues(prevValues => ({
      ...prevValues,
      [name]: checked,
    }))
  }

  // const handleSubmit = async e => {
  //   e.preventDefault()
  //   setLoading(true) // Start loader

  //   const user = JSON.parse(localStorage.getItem("user"))

  //   try {
  //     const emailResponse = await SendEmail({
  //       key: subscribeKey,
  //       reference_no: bookingDetails?.reference_no,
  //       user_id: String(user?.id),
  //       customer_email: emailValues?.sendToCustomer ? "1" : "0",
  //       company_email: emailValues?.sendToCompany ? "1" : "0",
  //       sms: emailValues?.sendSmsToCustomer ? "1" : "0",
  //     })

  //     if (emailResponse.response_code === 200) {
  //       toast.success(emailResponse?.message)
  //     } else {
  //       toast.error("Something Went Wrong")
  //     }
  //   } catch (error) {
  //     toast.error("Something Went Wrong")
  //   } finally {
  //     setLoading(false) // Stop loader
  //   }
  // }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true) 

    const { sendToCustomer, sendToCompany, sendSmsToCustomer } = emailValues;
    if (!sendToCustomer && !sendToCompany && !sendSmsToCustomer) {
      toast.error("Please select at least one option to send email or SMS.");
      setLoading(false); 
      return;
    }
  
    const user = JSON.parse(localStorage.getItem("user"))
  
    try {
      const emailResponse = await SendEmail({
        key: subscribeKey,
        reference_no: bookingDetails?.reference_no,
        user_id: String(user?.id),
        customer_email: sendToCustomer ? "1" : "0",
        company_email: sendToCompany ? "1" : "0",
        sms: sendSmsToCustomer ? "1" : "0",
      })
  
      if (emailResponse.response_code === 200) {
        toast.success(emailResponse?.message)
      } else {
        toast.error("Something Went Wrong")
      }
    } catch (error) {
      toast.error("Something Went Wrong")
    } finally {
      setLoading(false) // Stop loader
    }
  }

  return (
    <Card>
      <ModalBody>
        <Form>
          <Row form className="mt-3">
            <Col md={12}>
              <FormGroup check>
                <label check>
                  <Input
                    type="checkbox"
                    name="sendToCustomer"
                    defaultChecked
                    value={emailValues.sendToCustomer}
                    onClick={() =>
                      setEmailValues({
                        ...emailValues,
                        sendToCustomer: !emailValues.sendToCustomer,
                      })
                    }
                    className="border-primary"
                  />{" "}
                  Send Confirmation To Customer
                </label>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup check>
                <label check>
                  <Input
                    type="checkbox"
                    name="sendToCompany"
                    defaultChecked
                    value={emailValues.sendToCompany}
                    onClick={() =>
                      setEmailValues({
                        ...emailValues,
                        sendToCompany: !emailValues.sendToCompany,
                      })
                    }
                    className="border-primary"
                  />{" "}
                  Send Confirmation To Company
                </label>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup check>
                <label check>
                  <Input
                    type="checkbox"
                    name="sendSmsToCustomer"
                    checked={emailValues?.sendSmsToCustomer}
                    onClick={() =>
                      setEmailValues({
                        ...emailValues,
                        sendSmsToCustomer: !emailValues.sendSmsToCustomer,
                      })
                    }
                    className="border-primary"
                  />{" "}
                  Send SMS Confirmation to Customer
                </label>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="warning"
          size="sm"
          onClick={handleSubmit}
          disabled={loading}
          style={{ width: "120px" }}
        >
          {loading ? <Spinner size="sm" color="light" /> : "Submit Request"}
        </Button>{" "}
        <Button
          color="danger"
          size="sm"
          onClick={() => setActiveTab("")}
          disabled={loading}
        >
          Close
        </Button>
      </ModalFooter>
    </Card>
  )
}

export default EmailModal
